// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Mascotas from './pages/Mascotas';
import Servicios from './pages/Servicios';
import Agenda from './pages/Agenda';
import Facturacion from './pages/Facturacion';
import Settings from './pages/Settings';
import Reportes from './pages/Reportes';
import Portal from './pages/Portal';
import Usuarios from './pages/Usuarios';
import Roles from './pages/Roles';
import Permisos from './pages/Permisos';
import CategoriasRazas from './pages/CategoriasRazas';
import Productos from './pages/Productos';
import MainLayout from './components/Layout/MainLayout';
import { Toaster } from 'react-hot-toast';
// Todo el estilo principal ahora vive en src/index.css

const ProtectedRoute = ({ children, module = null }) => {
  const { isAuthenticated, can, authLoading, user } = useAuth();

  if (authLoading) return (
    <div className="flex items-center justify-center min-h-screen bg-[#0f172a] overflow-hidden">
      <div className="flex flex-col items-center gap-8">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-emerald-500/10 border-t-emerald-500 rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center animate-pulse">
            <div className="w-8 h-8 rounded-full bg-emerald-500/20 blur-md"></div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <p className="text-white/40 font-black uppercase tracking-[8px] text-[10px] animate-pulse">Descifrando Privilegios</p>
          <div className="h-0.5 w-12 bg-emerald-500 mt-4 rounded-full shadow-lg shadow-emerald-500/50"></div>
        </div>
      </div>
    </div>
  );

  if (!isAuthenticated) return <Navigate to="/login" />;
  
  // Si estamos en la raíz o login, permitir acceso si ya está autenticado
  if (!module) return <MainLayout>{children}</MainLayout>;

  // Validar permisos granulares para el resto de módulos
  if (user?.rol_id !== 1 && module && !can(module)) {
    // Si no tiene acceso al Dashboard, no redirigir a / (bucle infinito). 
    // En su lugar, dejarlo pasar pero que el Dashboard muestre un estado vacío o mensaje.
    if (module === 'Dashboard') return <MainLayout>{children}</MainLayout>;
    
    console.warn(`Intrusismo detectado en módulo: ${module}. Redirigiendo a zona segura.`);
    return <Navigate to="/" />; 
  }

  return <MainLayout>{children}</MainLayout>;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" reverseOrder={false} />
      <Router basename="/frontend">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute module="Dashboard"><Dashboard /></ProtectedRoute>} />
          <Route path="/agenda" element={<ProtectedRoute module="Agenda"><Agenda /></ProtectedRoute>} />
          <Route path="/clientes" element={<ProtectedRoute module="Clientes"><Clientes /></ProtectedRoute>} />
          <Route path="/mascotas" element={<ProtectedRoute module="Mascotas"><Mascotas /></ProtectedRoute>} />
          <Route path="/servicios" element={<ProtectedRoute module="Servicios"><Servicios /></ProtectedRoute>} />
          <Route path="/facturacion" element={<ProtectedRoute module="Ventas"><Facturacion /></ProtectedRoute>} />
          <Route path="/configuracion" element={<ProtectedRoute module="Configuracion"><Settings /></ProtectedRoute>} />
          <Route path="/reportes" element={<ProtectedRoute module="Reportes"><Reportes /></ProtectedRoute>} />
          <Route path="/portal" element={<ProtectedRoute module="Comando Visual"><Portal /></ProtectedRoute>} />
          <Route path="/usuarios" element={<ProtectedRoute module="Usuarios"><Usuarios /></ProtectedRoute>} />
          <Route path="/roles" element={<ProtectedRoute module="Roles"><Roles /></ProtectedRoute>} />
          <Route path="/permisos" element={<ProtectedRoute module="Permisos"><Permisos /></ProtectedRoute>} />
          <Route path="/catalogos" element={<ProtectedRoute module="Catálogos"><CategoriasRazas /></ProtectedRoute>} />
          <Route path="/productos" element={<ProtectedRoute module="Productos"><Productos /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
